/**
 * Vehicle Title Component
 * Fetches and displays vehicle title from REST API
 *
 * @package
 */

import { useState, useEffect } from '@wordpress/element';
import apiFetch from '@wordpress/api-fetch';
import { decodeHtmlEntities } from '../helpers/decodeHtmlEntities';

const VehicleTitle = ( { vehicleConfigId, className = '' } ) => {
	const [ vehicleTitle, setVehicleTitle ] = useState( '' );

	useEffect( () => {
		if ( ! vehicleConfigId ) {
			return;
		}

		apiFetch( {
			path: `/wp/v2/vehicle-configs/${ vehicleConfigId }`,
		} )
			.then( data => {
				if ( data?.title?.rendered ) {
					setVehicleTitle( data.title.rendered );
				}
			} )
			.catch( () => {} );
	}, [ vehicleConfigId ] );

	if ( ! vehicleTitle ) {
		return null;
	}

	return <h2 className={ className }>{ decodeHtmlEntities( vehicleTitle ) }</h2>;
};

export default VehicleTitle;
